import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheLegendBegins from "./sections/TheLegendBegins";
import TheVisualLegacy from "./sections/TheVisualLegacy";
import MasterOfTheCraft from "./sections/MasterOfTheCraft";
import SecureYourSession from "./sections/SecureYourSession";
import TheSanctuary from "./sections/TheSanctuary";
import RitualHours from "./sections/RitualHours";
import Footer from "@/reusable_sections/Footer";
import ArtistHero from "./sections/ArtistHero";
export default function HomePage() {
  return <div>
      <Header />
      <TheLegendBegins />
      <TheVisualLegacy />
      <MasterOfTheCraft />
      <ArtistHero />
      <SecureYourSession />
      <TheSanctuary />
      <RitualHours />
      <Footer />
    </div>;
}